import React from "react";
import TitleTextLayout from "../components/Base/TitleTextLayout";
import { Box, Container, Grid, useMediaQuery } from "@mui/material";
import { VERTICAL_SPACE, baseGrey } from "../graphic/theme";
import bagryImg from "../graphic/Images/bagry.png";
import bagryImgwebp from "../graphic/Images/bagry.webp";
import { theme } from "../../App";
import ArticleText from "../components/Base/ArticleText";

export default function ZemniPrace() {
  let _900to1050 = useMediaQuery(theme.breakpoints.between("900", "1050"));

  return (
    <div style={{}}>
      <Container
        maxWidth="lg"
        sx={{
          px: "0px !important",
          bgcolor: baseGrey,
          position: "relative",
          overflowX: "hidden",
          overflowY: "hidden",
          height: { xs: "720px", sm: "1000px", md: "680px" },
        }}
      >
        <Grid
          container
          spacing={2}
          columns={24}
          sx={{
            px: VERTICAL_SPACE,
            pt: "0px",
            pb: "0px",
            pr: "0px !important",
          }}
        >
          <Grid
            item
            xs={24}
            sm={24}
            md={24}
            lg={24}
            sx={{
              zIndex: "90",
              display: "flex",
              justifyContent: "flex-start",
              pr: "10px !important",
            }}
          >
            <ArticleText
              sxProps={{
                pt: { xs: "100px", sm: "120px", md: "150px" },
                maxWidth: { sm: "500px", md: "340px" },
              }}
              sxTitle={{ maxWidth: { sm: "340px", md: "340px" } }}
              sxText={{ maxWidth: { sm: "500px", md: "340px" } }}
              blueText="bagr-brno.cz"
              title="Zemní práce a pronájem bagrů"
              text="Zajišťujeme zemní a výkopové práce prostřednictvím traktorbagrů a rypadel. Více informací naleznete na našem webu: www.bagr-brno.cz"
              buttonText={"Zjistit víc"}
              onButtonClick={() => {
                if (window) {
                  window.open("https://bagr-brno.cz", "_blank");
                }
              }}
            />
          </Grid>
          <Box
            sx={{ position: { xs: "relative", sm: "static" }, width: "100%" }}
          >
            <Box
              sx={{
                position: { xs: "absolute", sm: "absolute" },
                right: { xs: 0, sm: 0, md: _900to1050 ? -230 : -100, lg: 0 },
                top: { xs: 0, sm: 400, md: 90 },
                mt: "40px",
              }}
            >
              <picture>
                <source srcSet={bagryImgwebp} type="image/webp" />
                <Box
                  component="img"
                  alt="Uvod"
                  src={bagryImg}
                  sx={{ height: { xs: "280px", sm: "500px" }, width: "auto" }}
                />
              </picture>
            </Box>
          </Box>
        </Grid>
      </Container>
    </div>
  );
}
